<script setup lang="ts">
const model = defineModel()
</script>

<template>
    <input v-model="model"
        class="outline-none block w-full rounded-md border-0 py-3 px-4 mb-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600" />
</template>

<style scoped></style>